import React from "react";
import { useField } from "formik";

interface myProps {
  label: React.ReactNode;
  name: string;
  id: string;
  className?: string;
  required?: boolean;
}

const MyCheckboxField: React.FC<myProps> = ({
  label,
  className,
  required,
  id,
  name,
}) => {
  const [field, meta] = useField({ name, type: "checkbox" });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    window.dataLayer?.push({
      event: "checkbox_change",
      fieldName: name,
      checked: e.target.checked,
    });
    field.onChange(e); // Keep Formik functionality
  };

  return (
    <div className={`fieldset w-full ${className || ""}`}>
      <input
        type="checkbox"
        id={id || name}
        className="cursor-pointer accent-primary w-4 h-4"
        {...field}
        checked={field.value || false}
        onChange={handleChange}
      />
      <label htmlFor={id || name} className="mr-2 ml-2 cursor-pointer">
        {label} {required && <span className="text-red-500 text-lg">*</span>}
      </label>
      {meta.touched && meta.error ? (
        <div className="error text-red-400 mt-1">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default MyCheckboxField;
